<!-- =========================================================================================
  File Name: DashboardAnalytics.vue
  Description: Dashboard Analytics
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="dashboard-analytics">
    <div class="vx-row">

      <!-- CARD 2: SUBSCRIBERS GAINED -->
      <div v-if="showInstitute" class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4 mb-base">
        <statistics-card-line icon="HomeIcon" :statistic="instituteCount" statisticTitle="총 학원수" :chartData="subscribersGained.series" type="area"></statistics-card-line>
      </div>

      <!-- CARD 3: ORDER RECIEVED -->
      <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4 mb-base">
        <statistics-card-line icon="UsersIcon" :statistic="studentCount" statisticTitle="총 수강생수" :chartData="ordersRecevied.series" color="warning" type="area"></statistics-card-line>
      </div>

      <!-- CARD 3: ORDER RECIEVED -->
      <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4 mb-base">
        <statistics-card-line icon="ShoppingBagIcon" :statistic="ordersheetCount" statisticTitle="교재주문 건수" :chartData="ordersRecevied.series" color="success" type="area"></statistics-card-line>
      </div>

      <!-- CARD 3: ORDER RECIEVED -->
      <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4 mb-base">
        <statistics-card-line icon="UsersIcon" :statistic="teacherCount" statisticTitle="총 교직원수" :chartData="ordersRecevied.series" color="danger" type="area"></statistics-card-line>
      </div>

    </div>
  </div>
</template>

<script>
import VueApexCharts from 'vue-apexcharts'
import StatisticsCardLine from '@/components/statistics-cards/StatisticsCardLine.vue'
import analyticsData from '@/views/dashboard/ui-elements/card/analyticsData.js'
import ChangeTimeDurationDropdown from '@/components/ChangeTimeDurationDropdown.vue'
import VxTimeline from '@/components/timeline/VxTimeline'

import { fetchData } from '@/api/module'

export default {
  data () {
    return {
      checkpointReward: {},
      subscribersGained: {},
      ordersRecevied: {},
      salesBarSession: {},
      supportTracker: {},
      productsOrder: {},
      salesRadar: {},
      analyticsData,
      dispatchedOrders: [],
      instituteCount: 0,
      studentCount: 0,
      ordersheetCount: 0,
      teacherCount: 0,
      institute_data: null,
      student_data: null,
      ordersheet_data: null,
      teacher_data: null,
      showInstitute: false
    }
  },
  computed: {
  },
  methods : {
    async fetch_institute_data () {
      const { data } = await fetchData('/dashboard/institute')
      this.institute_data = data.data
      this.instituteCount = this.institute_data.count
    },
    async fetch_student_data () {
      const { data } = await fetchData('/dashboard/student')
      this.student_data = data.data
      this.studentCount = this.student_data.count
    },
    async fetch_ordersheet_data () {
      const { data } = await fetchData('/dashboard/ordersheet')
      this.ordersheet_data = data.data
      this.ordersheetCount = this.ordersheet_data.count
    },
    async fetch_teacher_data () {
      const { data } = await fetchData('/dashboard/teacher')
      this.teacher_data = data.data
      this.teacherCount = this.teacher_data.count
    }
  },
  components: {
    VueApexCharts,
    StatisticsCardLine,
    ChangeTimeDurationDropdown,
    VxTimeline
  },
  created () {
    const userInfo = this.$store.getters.getUserInfo
    if (userInfo.userType === 'sysadmin') {
      this.showInstitute = true  
    }
    this.fetch_institute_data()
    this.fetch_student_data()
    this.fetch_ordersheet_data()
    this.fetch_teacher_data()
  }
}
</script>

<style lang="scss">
/*! rtl:begin:ignore */
#dashboard-analytics {
  .greet-user{
    position: relative;

    .decore-left{
      position: absolute;
      left:0;
      top: 0;
    }
    .decore-right{
      position: absolute;
      right:0;
      top: 0;
    }
  }

  @media(max-width: 576px) {
    .decore-left, .decore-right{
      width: 140px;
    }
  }
}
/*! rtl:end:ignore */
</style>
